export default __webpack_public_path__ + "static/media/icon_google-bigquery.80efd049.svg";